import { FC } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import SyntaxHighlighter from "react-syntax-highlighter";
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs";
import cn from "classnames";
import styles from "./index.module.scss";

interface ChatGptMarkdownProps {
  children: string;
}

const ChatGptMarkdown: FC<ChatGptMarkdownProps> = ({ children }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[[remarkGfm, { singleTilde: false }]]}
      components={{
        code({ node, inline, className, children, ...props }) {
          return !inline ? (
            <SyntaxHighlighter
              children={String(children).replace(/\n$/, "")}
              style={atomOneDark}
              wrapLongLines
              className={styles.codeTag}
            />
          ) : (
            <code className={cn(styles.code, className)} {...props}>
              {children}
            </code>
          );
        },
      }}
    >
      {children}
    </ReactMarkdown>
  );
};

export default ChatGptMarkdown;
